import { request } from "../network/request";
const db = "dn0";

//获取当前时间一年内的周期列表
export function getWeeklyList(tjrq) {
  return request({
    url: "system/getWeeklyList",
    method: "get",
    params: {
      db,
      tjrq,
    },
  });
}
//获取项目周团队工作信息
export function getTeamWorks(xmbh, weekDate) {
  return request({
    url: "pmp/xmzb/selectTeamWorks",
    method: "get",
    params: {
      db,
      xmbh,
      weekDate,
    },
  });
}

//获取项目周团队工作信息
export function getWorksDetails(xmbh, weekDate) {
  return request({
    url: "pmp/xmzb/selectWorksDetails",
    method: "get",
    params: {
      db,
      xmbh,
      weekDate,
    },
  });
}
// 查询周报编辑日志
export function getWeeklyLog(xmbh, weekDate) {
  return request({
    url: "pmp/xmzb/selectProjectWeeklyLog",
    method: "get",
    params: {
      db,
      xmbh,
      weekDate,
    },
  });
}
//根据数据类型获取字典列表
export function getDictData(dictType, type) {
  return request({
    url: "system/getDictData",
    method: "get",
    params: {
      db,
      dictType,
      type,
    },
  });
}
/**
 * 查询周报填写信息
 * @param {*} xmbh
 * @param {*} weekDate  周报日期 例20220418-20220424
 * @returns
 */
export function getProjectWeekly(xmbh, weekDate) {
  return request({
    url: "pmp/xmzb/selectProjectWeekly",
    method: "get",
    params: {
      db,
      xmbh,
      weekDate,
    },
  });
}
// 保存周报
export function saveProjectWeekly(params) {
  return request({
    url: "pmp/xmzb/saveProjectWeekly",
    method: "post",
    data: { ...params },
  });
}
// 获取项目本周团队成员工作详情导出路径，文件名
export function getExportWorksDetails(xmbh, weekDate) {
  return request({
    url: "pmp/xmzb/exportWorksDetails",
    method: "get",
    params: { xmbh, weekDate },
  });
}

//绩效管家-获取周报推送信息
export function getPushXmzb(xmbh, xmzq, type) {
  return request({
    url: "pmp/kh/getPushXmzb",
    method: "get",
    params: { xmbh, xmzq, type },
  });
}
//绩效管家-获取项目信息相关人
export function getKhfzrs(xmbh) {
  return request({
    url: "pmp/kh/getKhfzrs",
    method: "get",
    params: { xmbh },
  });
}

// 绩效管家-保存周报推送信息
export function pushXmzbSave(params) {
  return request({
    url: "pmp/kh/pushXmzbSave",
    method: "post",
    data: params,
  });
}
// 周报文件上传
export function zbUpload(params) {
  return request({
    url: "pmp/xqgl/zbUpload",
    method: "post",
    data: params,
  });
}
// 周报文件删除
export function fileDelete(params) {
  return request({
    url: "pmp/xqgl/fileDelete",
    method: "get",
    params,
  });
}
